"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationWatcherSourceEnum = void 0;
var ConversationWatcherSourceEnum;
(function (ConversationWatcherSourceEnum) {
    ConversationWatcherSourceEnum["Dashboard"] = "D";
    ConversationWatcherSourceEnum["Tab"] = "T";
    ConversationWatcherSourceEnum["DashboardCustomerJourney"] = "DJ";
    ConversationWatcherSourceEnum["TabCustomerJourney"] = "TJ";
})(ConversationWatcherSourceEnum = exports.ConversationWatcherSourceEnum || (exports.ConversationWatcherSourceEnum = {}));
